import type * as React from 'react'

import { clsx } from 'clsx'

import { Heading, Text } from '@buffer-mono/popcorn'

import styles from './PlanCard.module.css'

import type { JSX } from 'react'

interface PlanCardProps {
  children: React.ReactNode
  className?: string
}

const PlanCard = ({ className, children }: PlanCardProps): JSX.Element => {
  return <div className={clsx(styles.planCard, className)}>{children}</div>
}

interface IconProps {
  children: React.ReactNode
}

const Icon = ({ children }: IconProps): JSX.Element => {
  return (
    <div className={styles.iconWrapper}>
      <div className={styles.icon}>{children}</div>
    </div>
  )
}

interface HeadingProps {
  children: React.ReactNode
}

const Title = ({ children }: HeadingProps): JSX.Element => {
  return (
    <Text size="md" weight="bold" className={styles.heading}>
      {children}
    </Text>
  )
}

interface InfoProps {
  children: React.ReactNode
}

const Info = ({ children }: InfoProps): JSX.Element => {
  return (
    <Text size="md" color="subtle" className={styles.info}>
      {children}
    </Text>
  )
}

interface ValueProps {
  children: React.ReactNode
}

const Value = ({ children }: ValueProps): JSX.Element => {
  return (
    <Heading as="p" size="small" className={styles.value}>
      {children}
    </Heading>
  )
}

interface FootNoteProps {
  children: React.ReactNode
}

const FootNote = ({ children }: FootNoteProps): JSX.Element => {
  return <div className={styles.footNote}>{children}</div>
}

interface TextContentProps {
  children: React.ReactNode
}

const TextContent = ({ children }: TextContentProps): JSX.Element => {
  return <div className={styles.textContent}>{children}</div>
}

// Attach subcomponents
PlanCard.Icon = Icon
PlanCard.Title = Title
PlanCard.Info = Info
PlanCard.Value = Value
PlanCard.FootNote = FootNote
PlanCard.TextContent = TextContent

export default PlanCard
